<template>
  <div id="app">
      <div class="container">
        <Mobile></Mobile>
      </div>
  </div>
</template>

<script>
  import Mobile from './components/Mobile.vue';

  export default {
    name: 'app',

    components: {
      Mobile
    },

  };
</script>

<style>
  
</style>
